import React, { useEffect, useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import ReportGmailerrorredOutlinedIcon from '@mui/icons-material/ReportGmailerrorredOutlined'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import { api } from '../../../../services/api'
import './RecoverPassword.css'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const RecoverPassword = (props) => {
  const [email, setEmail] = useState('')
  const [verifyEmail, setVerifyEmail] = useState(false)
  const [loading, setLoading] = useState(false)
  const [messageErrorDialog, setMessageErrorDialog] = useState('')
  const [openErrorModal, setOpenErrorModal] = useState(false)
  const [openSuccessModal, setOpenSuccessModal] = useState(false)

  useEffect(() => {
    setVerifyEmail(regex.test(email))
  }, [email])

  const handleChange = (e) => {
    const { value } = e.target

    setEmail(value)
  }

  const handleSubmit = async () => {
    if (verifyEmail) {
      setLoading(true)
      const abortController = new AbortController()
      const { signal } = abortController
      const headers = {
        Accept: 'application/json, text/plain, */*',
      }

      try {
        await api
          .post(`/recoverpassword`, { email }, { headers }, { signal: signal })
          .then((response) => {
            // console.log('response: ', response)
            if (response.data) {
              // console.log('response.data: ', response.data)
              setLoading(false)
              setOpenSuccessModal(true)
            } else {
              setLoading(false)
              setMessageErrorDialog('Algo deu errado, solicite suporte!')
              setOpenErrorModal(true)
            }
          })
          .catch((err) => {
            setLoading(false)
            console.log('ERROR(handleSubmit): ', err)
            setMessageErrorDialog('Algo deu errado, tente mais tarde!')
            setOpenErrorModal(true)
          })
      } catch (err) {
        setLoading(false)
        console.log('ERROR(getTradeAssetsCombo): ', err)
        setMessageErrorDialog('Algo deu errado, tente mais tarde.')
        setOpenErrorModal(true)
      }
    }
  }

  return (
    <div className="recover-password-container">
      <div className="logo-recover-password">
        <img src="assets/images/froneri-white-logo.png" alt="Logo" className="logo-login" />
      </div>
      <h1>Recuperação de senha</h1>
      <h3>Informe seu e-mail</h3>
      <form
        onSubmit={() => {
          if (verifyEmail) handleSubmit()
        }}
      >
        <input type="email" autoComplete="off" onChange={handleChange} />
        <button
          className={verifyEmail && !loading ? 'btn-darkblue-recover-password' : 'btn-disabled'}
          type="submit"
        >
          {!loading && 'Solicitar nova senha'}
          {loading && (
            <div>
              <CircularProgress
                sx={{
                  color: (theme) => '#fff',
                }}
                size={20}
                thickness={4}
                value={100}
              />
            </div>
          )}
        </button>
      </form>
      <button
        className="btn-white-recover-password"
        onClick={() => props.setRecoverPassword(false)}
      >
        Voltar
      </button>

      <Dialog
        open={openErrorModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            // Set 'open' to false, however you would do that with your particular code.
            setOpenErrorModal(false)
          }
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <div className="icon-dialog">
            <ReportGmailerrorredOutlinedIcon className="icon-error-dialog" />
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component={'span'}>
            <div className="content-dialog-column-mobile">
              <span className="content-dialog-title-error">Atenção!</span>
              <span>{messageErrorDialog}</span>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="btn-dialog">
            <button type="button" className="btn-blue" onClick={() => setOpenErrorModal(false)}>
              OK
            </button>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openSuccessModal}
        TransitionComponent={Transition}
        keepMounted
        /* disableBackdropClick */
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            // Set 'open' to false, however you would do that with your particular code.
            openSuccessModal(false)
          }
        }}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          <div className="icon-dialog">
            <CheckCircleOutlineOutlinedIcon className="icon-success-dialog" />
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText component={'span'}>
            <div className="content-dialog-column">
              <span className="content-dialog-title-error">Tudo certo!</span>
              <span>Uma nova senha será enviada para seu e-mail.</span>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="btn-dialog">
            <button
              type="button"
              className="btn-blue"
              onClick={() => {
                props.setRecoverPassword(false)
                setOpenSuccessModal(false)
              }}
            >
              OK
            </button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default RecoverPassword
